//PACKS
import React, { useState, useEffect } from "react";
import { useSpring, animated } from "react-spring";
import { products } from "../assets/productsList";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";

//COMPONENTS
import ProductMobile from "./ProductMobile";
import ProductDesktop from "./ProductDesktop";

//STYLES
import "../styles/products.scss";
import "pure-react-carousel/dist/react-carousel.es.css";

export default function Products(props) {
  //STATES
  const [bgImg, setBackgroundImage] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(null);

  //RESETS CURRENT SLIDE TO 0 AFTER INIT (CAROUSEL INITS BEFORE STATE?)
  useEffect(() => {
    setTimeout(() => {
      setCurrentSlide(0);
    }, 100);
  }, []);

  //HANDLERS
  function numberOfSlides() {
    return products.length + 5;
  }

  function handleCurrentSlide(slide) {
    // console.log("currentSlide", currentSlide);
    // console.log("index", slide);
    // if (currentSlide !== slide) {
    //   setCurrentSlide(slide);
    // } else {
    //   setCurrentSlide(slide);
    // }
    setCurrentSlide(slide);
  }
  function handleBackgroundImage(bg) {
    setBackgroundImage(bg);
  }

  //ANIMATIONS
  const productContainerPicToggle = useSpring({
    opacity: bgImg ? 1 : 0,
  });
  const productsTitle = useSpring({
    color: bgImg ? "#e6e6e6" : "#262626",
  });
  const productsSeparator = useSpring({
    background: bgImg ? "#a1cec8" : "#06605a",
    boxShadow: bgImg ? "0 0 10px #88ffef" : "0 0 10px #06605a",
  });

  return (
    <div className="productsContainer">
      <div style={{ position: "absolute", top: "-4em" }} id="products" />
      <animated.div
        style={
          (productContainerPicToggle, { backgroundImage: `url(${bgImg})` })
        }
        className="productContainerPic"
      />
      <div className="productsTitleContainer">
        <animated.h2 style={productsTitle}>Servizi e prodotti</animated.h2>
        <animated.div style={productsSeparator} className="separator" />
      </div>
      {props.device === "desktop" ? (
        <div className="productsContainerDesktop">
          <CarouselProvider
            visibleSlides={5}
            naturalSlideWidth={30}
            naturalSlideHeight={80}
            totalSlides={numberOfSlides()}
            currentSlide={currentSlide}
            infinite={true}
            // dragEnabled={false}
          >
            <Slider>
              {products.map((product, index) => (
                <Slide
                  style={{
                    transform:
                      bgImg && index > currentSlide
                        ? "translatex(720px)"
                        : "translatex(0px)",
                  }}
                  className="slide"
                  key={index}
                  index={index}
                >
                  <ProductDesktop
                    product={product}
                    index={index}
                    handleBackgroundImage={handleBackgroundImage.bind(this)}
                    handleCurrentSlide={handleCurrentSlide.bind(this)}
                    currentSlide={currentSlide}
                  />
                </Slide>
              ))}
            </Slider>
            <div className="carouselButtons">
              <ButtonBack>
                <i className="fa fa-chevron-left" />
              </ButtonBack>
              <ButtonNext>
                {" "}
                <i className="fa fa-chevron-right" />
              </ButtonNext>
            </div>
          </CarouselProvider>
        </div>
      ) : (
        <>
          <CarouselProvider
            naturalSlideWidth={100}
            naturalSlideHeight={150}
            totalSlides={products.length}
          >
            <Slider>
              {products.map((product, index) => (
                <Slide key={index} index={index}>
                  <ProductMobile
                    product={product}
                    currentSlide={currentSlide}
                    index={index}
                    handleCurrentSlide={handleCurrentSlide.bind(this)}
                    handleBackgroundImage={handleBackgroundImage.bind(this)}
                  />
                </Slide>
              ))}
            </Slider>
          </CarouselProvider>
        </>
      )}
    </div>
  );
}
